import React from "react";
import AbuDhabi from '../UAE pictures/Abu-Dhabi3.jpg'
import Ajman from '../UAE pictures/Ajman1.jpg'
import Dubai from '../UAE pictures/Dubai2.jpg'
import Fujairah from '../UAE pictures/Fujairah1.jpg'
import RasAlKhaimah from '../UAE pictures/Ras-Al-Khaimah2.jpg'
import Sharjah from '../UAE pictures/Sharjah1.jpg'
import UmmAlQuwain from '../UAE pictures/Umm-Al-Quwain2.jpg'
import './emirates.css'
import { Link} from 'react-router-dom';
import {
    Image,
    Row,
    Col,
    Container,
} from "react-bootstrap";

export default function Emirates() {
    return (
        <div>
            <Container fluid="lg">
                <Row>
                    <Col className="mt-3" xs={12} md={6} lg={4} >
                        <div className="view overlay zoom">
                        <Link to={{
                                pathname: '/clinics/dubai',
                                state: { emirate: "Dubai"} 
                         }}>
                            <Image id='city' className="d-block w-100 rounded" src={Dubai} alt=""/>
                        </Link>
                        <h3 className="flex-center my-2">Dubai</h3>
                        </div>
                    </Col>
                    <Col className="mt-3" xs={12} md={6} lg={4} >
                        <div className="view overlay zoom">
                        <Link to={{
                                pathname: '/clinics/abu dhabi',
                                state: { emirate: "Abu Dhabi"} 
                         }}>
                            <Image id='city'className="d-block w-100 rounded" src={AbuDhabi} alt=""/>
                        </Link>
                            <h3 className="flex-center my-2">Abu Dhabi</h3>
                        </div>
                    </Col>
                    <Col className="mt-3" xs={12} md={6} lg={4} >
                        <div className="view overlay zoom">
                        <Link to={{
                                pathname: '/clinics/sharjah',
                                state: { emirate: "Sharjah"}
                         }}>
                            <Image id='city' className="d-block w-100 rounded" src={Sharjah} alt=""/>
                        </Link>
                            <h3 className="flex-center my-2">Sharjah</h3>
                        </div>
                    </Col>
                    <Col className="mt-3" xs={12} md={6} lg={3} >
                        <div className="view overlay zoom">
                        <Link to={{
                                pathname: '/clinics/ajman',
                                state: { emirate: "Ajman"} 
                         }}>
                            <Image id='city' className="d-block w-100 rounded " src={Ajman} alt=""/>
                        </Link>
                            <h3 className="flex-center my-2">Ajman</h3>
                        </div>
                    </Col>
                    <Col className="mt-3" xs={12} md={6} lg={3} >
                        <div className="view overlay zoom">
                        <Link to={{
                                pathname: '/clinics/fujairah',
                                state: { emirate: "Fujairah"} 
                         }}>
                            <Image id='city' className="d-block w-100 rounded" src={Fujairah} alt=""/>
                        </Link>
                            <h3 className="flex-center my-2">Fujairah</h3>
                        </div>
                    </Col>
                    <Col className="mt-3" xs={12} md={6} lg={3} >
                        <div className="view overlay zoom">
                        <Link to={{
                                pathname: '/clinics/ras al khaimah',
                                state: { emirate: "Ras Al Khaimah"} 
                         }}>
                            <Image id='city' className="d-block w-100 rounded" src={RasAlKhaimah} alt=""/>
                        </Link>
                            <h3 className="flex-center my-2">Ras Al Khaimah</h3>
                        </div>
                    </Col>
                    <Col className="mt-3" xs={12} md={6} lg={3} >
                        <div className="view overlay zoom">
                        <Link to={{
                                pathname: '/clinics/umm al quwain',
                                state: { emirate: "Umm Al Quwain"}
                         }}>
                            <Image id='city' className="d-block w-100 rounded" src={UmmAlQuwain} alt=""/>
                        </Link>
                            <h3 className="flex-center my-2">Umm al-Quwain</h3>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
        
    )
}